var _radialGradient, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 33 32",
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 20 -20 0 16.5 16)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.123195,
    stopColor: "#3a3c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17191c"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 0h32v32h-32z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.5 0c8.8366 0 16 7.16344 16 16 0 8.8366-7.1634 16-16 16-8.83656 0-16-7.1634-16-16 0-8.83656 7.16344-16 16-16z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.41325 11.4918c3.91385-3.85559 10.25955-3.85559 14.17345 0l.471.464c.1958.1927.1958.5054 0 .6981l-1.6113 1.5873c-.0978.0964-.2565.0964-.3544 0l-.6481-.6385c-2.7304-2.6898-7.1574-2.6898-9.8878 0l-.6941.6838c-.0979.0964-.2565.0964-.3544 0l-1.61132-1.5873c-.19569-.1928-.19569-.5054 0-.6981zm17.50585 3.2828 1.4341 1.4127c.1957.1927.1957.5052 0 .6981l-6.4664 6.3701c-.1958.1928-.5131.1928-.7087 0l-4.5895-4.5211c-.0489-.0482-.1282-.0482-.1772 0l-4.5893 4.5211c-.1957.1928-.513.1928-.7087 0l-6.46663-6.3702c-.19569-.1928-.19569-.5054 0-.6982l1.43409-1.4127c.1957-.1927.51298-.1927.70868 0l4.58956 4.5212c.0489.0482.1283.0482.1771 0l4.5894-4.5212c.1957-.1927.513-.1927.7086 0l4.5897 4.5212c.0488.0482.1282.0482.177 0l4.5895-4.521c.1957-.1929.513-.1929.7087 0z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet_connect.3ed913d1b2659d222fb5afcb05935997.svg";
export { ForwardRef as ReactComponent };